import apiInstance from "./api";

export const parseBrandTeams = async () => {
	return apiInstance.get(`/brandTeams/parseBrandTeams`);
};

export const getBrandTeams = async () => {
	return apiInstance.get(`/brandTeams`);
};
export const createBrandTeam = async (brandTeam) => {
	return apiInstance.post(`/brandTeams`, brandTeam);
};
export const getBrandTeamById = async (id) => {
	return apiInstance.get(`/brandTeams/GetById/${id}`);
};
export const getBrandTeamRiders = async (id, params = {}) => {
	return apiInstance.get(`/brandTeams/${id}/riders`, { params });
};
export const updateBrandTeam = async (id, brandTeam) => {
	return apiInstance.put(`/brandTeams/${id}`, brandTeam);
};

export const assignBrandTeams = async (brandTeamId) => {
	return apiInstance.post(`/brandTeams/assignBrandTeams`);
};

export const addTeamsFromFile = async () => {
	return apiInstance.post(`/brandTeams/addteams/fromfile/dh`);
};

export const syncBrandTeamLogosFromFile = async (dryRun = false) => {
	return apiInstance.post(`/brandTeams/addlogos/fromfile`, null, {
		params: { dryRun },
	});
};

export const getFeaturedBrandTeams = async () => {
	return apiInstance.get(`/brandTeams/featured`);
};


export const uploadBrandTeamImage = async (id, formData) => {
	return apiInstance.post(`/brandteams/upload/brandphoto/${id}`, formData);
};

